import Model from "./base/model";

class Quotation extends Model{
  resourceName() {
    return "quotations";
  }

  fields() {
    return {
      type: "",
      sent_at: "",
      last_active_status_id: "",
      status: {jsonApi: "hasMany", type: "quotation_status"},
      banks: "",
      solicitations: {jsonApi: "hasMany", type: "quotation_solicitations"},
      company: {jsonApi: "hasOne", type: "companies"},
      fintech: {jsonApi: "hasOne", type: "fintechs"},
      has_anticipation: "",
      ready: "",
      invoice: {jsonApi: "hasOne", type: "quotation_invoices"},
      is_new_bank: "",
      updated_at: "",
      value: "",
      chat_room: {jsonApi: "hasOne", type: "chat_rooms"},
      logs: {jsonApi: "hasMany", type: "quotation_logs"},
      quotation_number: "",
      users: {jsonApi: "hasOne", type: "users"},
      proposal_pending: "",
      cancelation_observation: "",
      modalities: {jsonApi: "hasMany", type: "quotation_modalities"},
      observation: "",
    }
  }

  async cotar(id, data) {
    return this.request(
      this.resourceName() + "/cotar/" + id,
      "POST",
      {},
      data
    );
  }

  async approveCotar(id) {
    return this.request(
      this.resourceName() + "/approve_cotar/" + id,
      "POST",
      {},
      {},
    );
  }

  async visualized(id) {
    return this.request(
      this.resourceName() + "/visualized/" + id,
      "POST",
      {},
      {},
    )
  }

  async simpleCotar(id, data) {
    return this.request(
      this.resourceName() + "/simple_cotar/" + id,
      "POST",
      {},
      data
    );
  }

  async syncDocuments(id) {
    return this.request(
      this.resourceName() + "/sync_documents/" + id,
      "POST",
      {},
      {},
    );
  }
}

export default new Quotation();
